
	import { defineComponent } from "vue";
	import { QuoteItem } from "@/domain/entities/Misc";

	export default defineComponent({
		props: {
			items: {
				type: Array,
				default: () => [] as QuoteItem[],
			},
		},
	});
